'use strict'

const { fields } = require('cloud-utils/config/device-settings/default-v2.json')

angular
  .module('surfsightApp.controllers')
  .controller('organizationDeviceSettingsEditController', [
    '$scope',
    '$mdDialog',
    '$rootScope',
    '$http',
    '$localStorage',
    'isOrgDeviceSettings',
    function (
      $scope,
      $mdDialog,
      $rootScope,
      $http,
      $localStorage,
      isOrgDeviceSettings
    ) {
      $scope.isOrgDeviceSettings = isOrgDeviceSettings
      const uiSettings =
        $rootScope.organizationSettings.organizationDeviceSetting
      Object.keys(uiSettings).map(field => {
        uiSettings[field].allowInBulk = true
        if (field === 'standby') {
          uiSettings[field].value = uiSettings[field].timeout
        }
      })
      $scope.uiSettings = uiSettings

      const userType = $localStorage.userDetails.type
      const partnerId =
        $localStorage.currentUserOrganization.reseller_id ||
        (userType === 'reseller' ||
        userType === 'sub-reseller' ||
        userType === 'reseller-contact'
          ? $localStorage.userDetails.id
          : null)
      // Check if recording encryption feature is enabled
      $scope.isRecordingEncryptionFeatureEnabled = false
      const featureFlagRequest = {
        method: 'POST',
        url: `${EDGE_BASEURL}/red-recording-encryption-feature`,
        data: {
          partnerId
        }
      }
      $http(featureFlagRequest)
        .then(featureFlagResponse => {
          $scope.isRecordingEncryptionFeatureEnabled =
            featureFlagResponse.data.enabled || false
        })
        .catch(featureFlagError => {
          console.error(
            'Failed to check encryption feature flag:',
            featureFlagError
          )
          $scope.isRecordingEncryptionFeatureEnabled = false
        })
      $scope.confirmUpdateUiSettings = () => {
        if (
          $scope.isRecordingEncryptionFeatureEnabled &&
          $scope.isOrgDeviceSettings &&
          $scope.uiSettings.recordingEncryption
        ) {
          delete $scope.uiSettings.recordingEncryption
        }
        if ($scope.uiSettings.standby) {
          $scope.uiSettings.standby.timeout = $scope.uiSettings.standby.value
          delete $scope.uiSettings.standby.value
        }
        $mdDialog.hide($scope.uiSettings)
      }
      $scope.cancel = () => {
        $mdDialog.cancel()
      }
    }
  ])
